import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ApplicationState,
  getSelectedProductAvailableOptionsError,
  getSelectedProductAvailableOptionsLoaded,
  getSelectedProductDetails,
} from '../../../../store/reducers';
import { MobileProduct, Option } from '@dch/products-business-logic';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { Store } from '@ngrx/store';
import { GetProductDetails } from '../../../../store/actions/product-details.actions';
import { getPiiServiceId } from '../../../../shared/pii/pii.utils';
import { WebshopUtils } from '../../../../shared/webshop/webshop-utils';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { Alert, AlertsService } from '@proximus/ng-common-components';
import { combineLatest } from 'rxjs';
import { buildTaggingProduct } from '../../../../tagging/tagging.utils';
import { getDescriptionMessage } from '../../../../shared/order-utils/order-utils';

@Component({
  selector: 'mprd-data-boost',
  templateUrl: './data-boost.component.html',
})
export class DataBoostComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  mobileProduct: MobileProduct;
  accessNumber: string;
  isExpanded = false;
  dataBoosts: Option[];
  selectedOption: Option;
  orderButtonsDisabled = false;
  availableOptionsLoaded: boolean;
  hasError: boolean;

  buildTaggingProduct = buildTaggingProduct;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private alertService: AlertsService,
    private inceptionService: InceptionService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.route.params.subscribe((params) => {
        this.store.dispatch(
          new GetProductDetails({
            productType: 'mobile',
            serviceId: getPiiServiceId(),
          }),
        );
      }),
    );

    this.addSubscription(
      this.store
        .select(getSelectedProductAvailableOptionsError)
        .subscribe((value) => {
          this.hasError = !!value;
        }),
    );

    this.addSubscription(
      combineLatest([
        this.store.select(getSelectedProductDetails),
        this.store.select(getSelectedProductAvailableOptionsLoaded),
      ]).subscribe(([selectedProduct, selectedProductLoaded]) => {
        this.availableOptionsLoaded = selectedProductLoaded;
        if (
          selectedProduct &&
          selectedProduct.mobileProductDetails &&
          JSON.stringify(this.mobileProduct) !==
            JSON.stringify(selectedProduct.mobileProductDetails)
        ) {
          this.mobileProduct = selectedProduct.mobileProductDetails;
          if (this.mobileProduct) {
            this.accessNumber = this.mobileProduct?.accessNumber;
            if (
              this.mobileProduct.options &&
              this.filterDataBoost(this.mobileProduct.options).length > 0
            ) {
              this.dataBoosts = this.filterDataBoost(
                this.mobileProduct.options,
              );
            }
            WebshopUtils.publishCartRetrival(
              this.mobileProduct.installationId,
              this.mobileProduct.accessNumber,
              this.mobileProduct.plc,
            );
          }
        }
      }),
    );
    this.scrollToTop();
  }

  filterDataBoost(options: Option[]) {
    return options.filter((option) => option.categories.includes('DATABOOST'));
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  redirectToOptionsSection() {
    this.router.navigate(['/details/mobile'], {
      fragment: 'available-options',
    });
  }

  onResult(event) {
    if (event && event.orderingInProgress) {
      this.orderButtonsDisabled = true;
    } else if (event && event.type && event.type === 'success') {
      if (event.action && event.action === 'add') {
        this.dispatchAlert(
          event.type,
          this.translationService.getTranslatedValueFor(
            'message.confirmation.title',
          ),
          this.translationService.getTranslatedValueFor(
            'message.confirmation.description',
          ),
          true,
        );
        this.orderButtonsDisabled = false;
      }
    } else if (event && event.type && event.type === 'error') {
      this.dispatchAlert(
        'error',
        this.translationService.getTranslatedValueFor('message.error.title'),
        getDescriptionMessage(event, this.translationService),
        true,
      );
      this.orderButtonsDisabled = false;
    }
  }

  private dispatchAlert(
    type: 'error' | 'info' | 'success' | 'warning',
    title: string,
    description: string,
    isClosable: boolean,
  ): void {
    const alert: Alert = {
      isClosable,
      alertKey: 'dataBoostAlert',
      title,
      description,
      type,
    };
    this.alertService.dispatchAlert(alert);
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#data-full-speed');
    });
  }
}
